export const getRestaurantInfo = state => state.RestaurantReducer